/* eslint-disable */
import { Bar } from 'react-chartjs-2';
import { Box, useTheme } from '@material-ui/core';

const CategoryTotalgraph = (props) => {
  const { graphdata, yokoziku, setTanni } = props; // eslint-disable-line

  const theme = useTheme();
  const data = {
    datasets: [
      {
        // グラフの色
        backgroundColor: '#738DC4',
        borderColor: '#718CC6',
        titleColor: '#718CC6',
        data: graphdata,
        maxBarThickness: 30,
        barThickness: 'flex'
      }
    ],
    labels: yokoziku
  };
  const options = {
    interaction: {
      mode: 'nearest',
      intersect: false
    },
    animation: true,
    // 上下の余白を揃える（下だけ大きく空けない）
    layout: { padding: { top: 8, right: 8, bottom: 8, left: 8 } },
    legend: {
      display: false
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        ticks: {
          fontColor: theme.palette.text.secondary,
          font: {
            family: "'M PLUS 1p', sans-serif",
            size: '10px'
          },
          maxRotation: 40,
          minRotation: 0,
          autoSkip: true,
          autoSkipPadding: 4,
          padding: 4
        },
        grid: {
          display: false,
          drawBorder: false
        },
        title: {
          display: false
        }
      },
      y: {
        ticks: {
          fontColor: theme.palette.text.secondary,
          font: {
            family: "'M PLUS 1p', sans-serif"
          },
          beginAtZero: true,
          min: 1,
          padding: 4,
          callback: function (value, index, values) {
            let returnValue = value;
            let returnStr = '';
            let length = values.length;
            let kijunValue = values[length - 1].value;
            if (kijunValue >= 100000000) {
              setTanni('億円');
              returnValue = value / 100000000;
              returnStr = returnValue.toLocaleString(); //億円
            } else if (kijunValue >= 1000000) {
              setTanni('百万円');
              returnValue = value / 1000000;
              returnStr = returnValue.toLocaleString(); //百万円
            } else if (kijunValue >= 10000) {
              setTanni('万円');
              returnValue = value / 10000;
              returnStr = returnValue.toLocaleString(); //万円
            } else {
              setTanni('円');
              returnValue = value;
              returnStr = returnValue.toLocaleString(); //円
            }
            // ラベルの前に￥マークを追加
            return returnStr;
          }
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider
        }
      }
    },
    plugins: {
      tooltip: {
        titleFont: {
          family: "'M PLUS 1p', sans-serif"
        },
        bodyFont: {
          family: "'M PLUS 1p', sans-serif"
        }
      },
      legend: {
        display: false,
        labels: {
          boxWidth: 10,
          boxHeight: 10
        }
      },
      datalabels: {
        display: false
      }
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        minHeight: 220,
        minWidth: 0
      }}
    >
      <Bar data={data} options={options} />
    </Box>
  );
};

export default CategoryTotalgraph;
